import React, { useState } from "react";
import {
  FaTimes,
  FaFilter,
  FaSortAlphaDown,
  FaSortAmountDown,
  FaCheck,
  FaRegTimesCircle,
} from 'react-icons/fa';

const FilterModel = ({ isOpen, onClose, onApply }) => {
    const [localFilters, setLocalFilters] = useState({
        per_page: 10,
        page: 1,
        order_by: "created_at",
        status: "all",
      });
      
      const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
      
      const applyFilters = () => {
        onApply(localFilters);
      };
      
      return (
       
        
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 z-50 ${
            isOpen ? 'flex' : 'hidden'
          } justify-center items-center transition duration-300 ease-in-out`}
        >
          <div className="bg-white p-6 rounded-2xl shadow-xl w-[90%] max-w-md relative">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
              <FaFilter className="text-blue-500" />
              Filter Outlet
            </h2>
        
            <div className="space-y-4 text-sm">
              {/* Per Page */}
              <div>
                <label className="block mb-1 text-gray-600 font-medium flex items-center gap-1">
                  <FaSortAmountDown className="text-gray-400" />
                  Per Page
                </label>
                <input
                  type="number"
                  name="per_page"
                  value={localFilters.per_page}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300 outline-none"
                />
              </div>
        
              {/* Page */}
              <div>
                <label className="block mb-1 text-gray-600 font-medium flex items-center gap-1">
                  <FaSortAmountDown className="text-gray-400" />
                  Page
                </label>
                <input
                  type="number"
                  name="page"
                  value={localFilters.page}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300 outline-none"
                />
              </div>
        
              {/* Order By */}
              <div>
                <label className="block mb-1 text-gray-600 font-medium flex items-center gap-1">
                  <FaSortAlphaDown className="text-gray-400" />
                  Order By
                </label>
                <select
                  name="order_by"
                  value={localFilters.order_by}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300 outline-none bg-white"
                >
                  <option value="created_at">Created At</option>
                  <option value="name">Name</option>
                  <option value="city">City</option>
                </select>
              </div>
        
              {/* Status */}
              <div>
                <label className="block mb-1 text-gray-600 font-medium flex items-center gap-1">
                  <FaCheck className="text-gray-400" />
                  Status
                </label>
                <select
                  name="status"
                  value={localFilters.status}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-300 outline-none bg-white"
                >
                  <option value="all">All</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
        
            {/* Action Buttons */}
            <div className="mt-6 space-y-2">
              <button
                onClick={applyFilters}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition-all font-medium flex items-center justify-center gap-2"
              >
                <FaFilter />
                Apply Filters
              </button>
              <button
                onClick={onClose}
                className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 py-2 rounded-lg transition-all font-medium flex items-center justify-center gap-2"
              >
                <FaRegTimesCircle />
                Close
              </button>
            </div>
        
            {/* Close Button Top Right */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-400 hover:text-red-500 transition"
            >
              <FaTimes size={16} />
            </button>
          </div>
        </div>
        
  );
};

export default FilterModel;
